import React from "react";

import Text from "src/components/text";
import { getAuthorName } from "src/services/reports.service";

import { Asset } from "src/types/assets";
import { Analytics } from "src/types/reports";

import styles from "./styles.module.scss";

export interface TopEngagedAssetCardProps {
  item: {
    asset: Asset;
    analytics: Analytics;
    reactions: number | null;
    comments: number | null;
  };
}

const DefaultAssetIcon = "/images/defaultIcons/default_asset.jpg";

const TopEngagedAssetCard: React.FC<TopEngagedAssetCardProps> = ({ item }) => {
  const { asset, reactions, comments } = item;

  return (
    <a
      href={`/assets/${asset.id}?source=reports`}
      target="_blank"
      rel="noopener noreferrer"
      className={styles.linkWrapper}
    >
      <div className={styles.card}>
      <img
        src={asset.icon?.thumbnail || DefaultAssetIcon}
        alt={asset.name}
        className={styles.thumbnail}
      />
      <div className={styles.content}>
        <Text text={asset.name || ""} lines={1} className={styles.title} />
        <div className={styles.metrics}>
          <span>{reactions || 0} Reaction</span>
          <span>{comments || 0} Comments</span>
        </div>
        <div className={styles.meta}>
          Author:{" "}
          <Text
            text={asset.author ? getAuthorName(asset.author) : ""}
            lines={1}
            className={styles.author}
          />
        </div>
      </div>
      </div>
    </a>
  );
};

export default TopEngagedAssetCard;
